"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayCardNavigation = void 0;
var _link = _interopRequireDefault(require("@clayui/link"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Context = _interopRequireDefault(require("./Context"));
var _excluded = ["children", "className", "horizontal", "href", "onClick"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var ClayCardNavigation = exports.ClayCardNavigation = function ClayCardNavigation(_ref) {
  var children = _ref.children,
    className = _ref.className,
    horizontal = _ref.horizontal,
    href = _ref.href,
    onClick = _ref.onClick,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Container = href ? _link.default : 'div';
  return /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: {
      horizontal: horizontal,
      interactive: true
    }
  }, /*#__PURE__*/_react.default.createElement(Container, _extends({
    className: (0, _classnames.default)(className, 'card card-interactive card-interactive-primary card-type-template', {
      'template-card': !horizontal,
      'template-card-horizontal': horizontal
    }),
    href: href,
    onClick: onClick,
    role: onClick ? 'button' : undefined
  }, otherProps), children));
};